var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-integration-list"},_vm._l((_vm.items),function(item){return _c('div',{key:item.name},[_c('AppIntegration',{staticClass:"py-2",attrs:{"app_logo":item.logo,"app_name":item.name,"app_description":item.description,"is_active":item.is_active,"learn_more":item.learn_more}}),_c('hr',{staticClass:"hr mb-6"})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }